export enum PostMessageCodes {
  // Action triggers for Parent app re-direction logic.
  DIGITAL_CLAIM_V2_LAUNCH_SAFELITE = 'DIGITAL_CLAIM_V2_LAUNCH_SAFELITE',
  DIGITAL_CLAIM_V2_LAUNCH_TG_SAFELITE = 'DIGITAL_CLAIM_V2_LAUNCH_TG_SAFELITE',
  DIGITAL_CLAIM_V2_RELOAD_BUTTON_CLICK = 'DIGITAL_CLAIM_V2_RELOAD_BUTTON_CLICK',
  // Action triggers for Parent app UI events.
  DIGITAL_CLAIM_V2_SCROLL = 'DIGITAL_CLAIM_V2_SCROLL',
  DIGITAL_CLAIM_V2_APP_IS_ACTIVE = 'DIGITAL_CLAIM_V2_APP_IS_ACTIVE',
  // Error notifications for Parent app for service call failures.
  DIGITAL_CLAIM_V2_SESSION_TIMEOUT_ERROR = 'DIGITAL_CLAIM_V2_SESSION_TIMEOUT_ERROR',
  DIGITAL_CLAIM_V2_USER_SESSION_VALIDATE_FAIL_ERROR = 'DIGITAL_CLAIM_V2_USER_SESSION_VALIDATE_FAIL_ERROR',
  DIGITAL_CLAIM_V2_CLAIM_DETAIL_FAIL_ERROR = 'DIGITAL_CLAIM_V2_CLAIM_DETAIL_FAIL_ERROR',
  DIGITAL_CLAIM_V2_POLICY_RETRIEVAL_ERROR = 'DIGITAL_CLAIM_V2_POLICY_RETRIEVAL_ERROR',
  DIGITAL_CLAIM_V2_SAFE_LITE_PAYLOAD_FAIL_ERROR = 'DIGITAL_CLAIM_V2_SAFE_LITE_PAYLOAD_FAIL_ERROR',
  DIGITAL_CLAIM_V2_DRAFT_CLAIM_CREATE_ERROR = 'DIGITAL_CLAIM_V2_DRAFT_CLAIM_CREATE_ERROR',
  DIGITAL_CLAIM_V2_DRAFT_CLAIM_DELETE_ERROR = 'DIGITAL_CLAIM_V2_DRAFT_CLAIM_DELETE_ERROR',
  DIGITAL_CLAIM_V2_CONVERSE_NEXT_ERROR = 'DIGITAL_CLAIM_V2_CONVERSE_NEXT_ERROR',
  DIGITAL_CLAIM_V2_CONVERSE_BACK_ERROR = 'DIGITAL_CLAIM_V2_CONVERSE_BACK_ERROR',
  DIGITAL_CLAIM_V2_CONVERSE_EDIT_ERROR = 'DIGITAL_CLAIM_V2_CONVERSE_EDIT_ERROR',
  DIGITAL_CLAIM_V2_CONVERSE_SUBMIT_ERROR = 'DIGITAL_CLAIM_V2_CONVERSE_SUBMIT_ERROR',
  DIGITAL_CLAIM_V2_ALL_CLAIMS_RETRIEVAL_ERROR = 'DIGITAL_CLAIM_V2_ALL_CLAIMS_RETRIEVAL_ERROR',
  DIGITAL_CLAIM_V2_AUTO_ELIGIBLE_SERVICES_ERROR = 'DIGITAL_CLAIM_V2_AUTO_ELIGIBLE_SERVICES_ERROR',
  DIGITAL_CLAIM_V2_AUTO_CLAIM_SUBMIT_TIMEOUT_ERROR = 'DIGITAL_CLAIM_V2_AUTO_CLAIM_SUBMIT_TIMEOUT_ERROR',
  DIGITAL_CLAIM_V2_AUTO_DRP_SHOPS_RETRIEVAL_FAIL_ERROR = 'DIGITAL_CLAIM_V2_AUTO_DRP_SHOPS_RETRIEVAL_FAIL_ERROR',
  DIGITAL_CLAIM_V2_AUTO_DRP_SHOP_SELECTION_FAIL_ERROR = 'DIGITAL_CLAIM_V2_AUTO_DRP_SHOP_SELECTION_FAIL_ERROR',
  DIGITAL_CLAIM_POST_FNOL_GO_TO_CLAIMS = 'POST_FNOL_GO_TO_CLAIMS',
  // To receive the post message from Bridge App
  BRIDGE_APP_HOSTED_STATE = 'HOSTED_BY_BRIDGE_APP',
}
